import React from 'react';
import { LocalShipping, AttachMoney, PowerSettingsNew, Lock, QuestionAnswer, LibraryBooks, Description, Home, GetApp, Help } from '@material-ui/icons';

const homeNavItems = [
    {
        text: 'Home', 
        icon: <Home />, 
        to: '/'
    }
];

const actionNavItems = [
    {
        text: 'Loads', 
        icon: <LocalShipping />, 
        to: '/loads'
    }, 
    {
        text: 'Logs', 
        icon: <LibraryBooks />, 
        to: '/logs'
    }, 
    {
        text: 'Settlement', 
        icon: <AttachMoney />, 
        to: '/settlement'
    }
];

const accountNavItems = [
    {
        text: 'Change Password', 
        icon: <Lock />, 
        to: '/change-password'
    }, 
    {
        text: 'Security Questions', 
        icon: <QuestionAnswer />, 
        to: '/security-questions'
    }, 
    {
        text: 'Fuel Guide', 
        icon: <Description />, 
        to: 'https://portals.leonardsexpress.com/driverportal/documents/Fueling_Guide.htm?t=1546865779', 
        target: '_blank', 
        component: React.forwardRef(({ to, ...props }, ref) => <a href={to} ref={ref} {...props}>{props.children}</a>)
    }
];

const helpNavItems = [
    {
        text: 'Paylocity', 
        icon: <AttachMoney />, 
        to: '/paylocity'
    }, 
    {
        text: 'Help', 
        icon: <Help />, 
        to: '/faq'
    }
]

const lastNavItems = [
    {
        text: 'Logoff', 
        icon: <PowerSettingsNew />, 
        to: '/logout'
    }
];

const buildNavigationItemsList = (isInstalledApp, installPrompt) => {
    const navigationItems = [
        { menuItems: homeNavItems }, 
        { menuItems: actionNavItems }, 
        { menuItems: accountNavItems }, 
        { menuItems: helpNavItems }
    ];

    if(isInstalledApp === false && installPrompt) {
        const installToHomeScreenItem = {
            text: 'Install App', 
            icon: <GetApp />, 
            to: '/', 
            onClick: () => {
                installPrompt.prompt();
            }
        };

        navigationItems.push({ menuItems: [ installToHomeScreenItem ]} );
    }

    navigationItems.push({ menuItems: lastNavItems });

    return navigationItems;
};

export default buildNavigationItemsList;